/**
 * Filtra el árbol de menú según el rol logueado.
 *
 * - Un ítem sin `roles` es visible para todos.
 * - Un submenú desaparece cuando ninguno de sus hijos sobrevive al filtro.
 * - La prop `roles` se descarta del resultado: NavigationLayout no la conoce.
 */
const filterMenuByRole = (items, roleId) =>
  items
    .filter((item) => !item.roles || item.roles.includes(roleId))
    .map(({ roles, subMenuItems, ...item }) => {
      if (!subMenuItems) return item;
      return { ...item, subMenuItems: filterMenuByRole(subMenuItems, roleId) };
    })
    .filter((item) => !item.subMenuItems || item.subMenuItems.length > 0);

export default filterMenuByRole;
